import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAttachmentsForLead as GetAttachmentsForLeadQuery,
    GetAttachmentsForLead_lead_files as File,
    GetAttachmentsForLeadVariables,
} from 'nutshell-graphql-types';

import GET_ATTACHMENTS_FOR_LEAD from '../queries/get-attachments-for-lead.graphql';

export const useGetAttachmentsForLead = (
    leadId: string
): {
    files: File[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAttachmentsForLeadQuery,
        GetAttachmentsForLeadVariables
    >(GET_ATTACHMENTS_FOR_LEAD, {
        variables: {
            leadId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        files: data && data.lead && data.lead.files,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
